<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
/* import echarts from "echarts"; */
import resize from "./mixins/resize";
import axios from "axios";
export default {
  mixins: [resize],
  props: {
    type: {
      type: String,
      default: "home",
    },
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    geoPath: {
      type: String,
      default: "/js/henan.json",
    },
  },
  data() {
    return {
      chart: null,
      charHoverSign: false,
      options: {
        geo: {
          map: "henan",
          aspectScale: 1.2,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize: "10",
              },
              formatter(v) {
                return v.name.replace("街道", "街");
              },
            },
            emphasis: {
              textStyle: {
                color: "#fff",
                fontSize: "20",
              },
            },
          },
          roam: true,
          zoom: 1,
          itemStyle: {
            normal: {
              borderColor: "RGBA(8, 143, 137, 1)",
              borderWidth: 3,
              areaColor: "RGBA(8, 35, 64, .3)",
            },
            emphasis: {
              areaColor: "#389BB7",
              borderWidth: 0,
            },
          },
        },
        // tooltip: {
        //   hideDelay: 500,
        //   enterable: true,
        //   transitionDuration: 0.5,
        //   position: function(pos, params, dom, rect, size) {
        //     return [pos[0], pos[1]];
        //   },
        //   trigger: 'item',
        //   backgroundColor: 'rgba(0,0,0,0)',
        //   formatter: function(item) {
        //     var tipHtml1 = '';
        //     let data = convertLineData(item.name);
        //     tipHtml1 =
        //       '' +
        //       ' <div class="dialog_list" ><div class="dialog_list_title">' +
        //       item.name +
        //       '<div class="title">' +
        //       '<span class="name">服务企业</span>';
        //     '<span class="count">家</span>' + '</div>';
        //     '</div>' + ' </div>';
        //     return tipHtml1;
        //   }
        // },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setChartData();
      },
    },
    geoPath: {
      deep: true,
      handler(val) {
        this.getGeoJson(val);
      },
    },
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  created() {
    window.vmm = this;
  },
  methods: {
    chartClick(params) {
      this.$emit("handleClick", params);
    },
    chartHover(params) {
      this.$emit("handleMouseOver", params);
    },
    chartOut(params) {
      this.$emit("handleMouseOut", params);
    },
    globalout(params) {
      this.$emit("globalout", params);
    },
    renderItem(params, api) {
      var coords = [
        [113.610477, 34.791399],
        [113.846192, 34.772425],
        [113.789851, 34.619043],
        [113.583456, 34.605258],
      ];
      var points = [];
      for (var i = 0; i < coords.length; i++) {
        points.push(api.coord(coords[i]));
      }

      var color = api.visual("color");

      const data = {
        type: "polygon",
        shape: {
          points: [
            [806, 396],
            [630, 510],
            [755, 640],
            [860, 638],
            [845, 443],
          ],
        },
        style: api.style({
          fill: "#f73131",
          stroke: echarts.color.lift("#f73131"),
        }),
      };

      return data;
    },
    setChartData() {
      this.options.visualMap = [
        {
          type: "piecewise",
          min: 0,
          right: 10,
          bottom: 0,
          showLabel: !0,
          textGap: 15,
          align: "left",
          text: ["企业数量", ""],
          itemWidth: 10, //图形的宽度，即长条的宽度。
          itemHeight: 20,
          itemGap: 0,
          textStyle: {
            color: "#ffffff",
            textBorderColor: "#ffffff",
          },
          pieces: [
            {
              symbol: "rect",
              gt: 10,
              label: "10家以上",
              color: {
                type: "linear",
                x: 1,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "RGBA(75, 51, 23, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 0.4,
                    color: "RGBA(165, 106, 32, 1)",
                  },
                  {
                    offset: 1,
                    color: "RGBA(75, 51, 23, 1)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            {
              symbol: "rect",
              lte: 9,
              gt: 6,
              label: "6-9家",
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "RGBA(10, 46, 76, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 0.4,
                    color: "RGBA(35, 111, 177, 1)",
                  },
                  {
                    offset: 1,
                    color: "RGBA(17, 57, 91, 1)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            {
              symbol: "rect",
              lte: 5,
              gte: 1,
              label: "1-5家",
              color: {
                type: "linear",
                x: 1,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "RGBA(5, 84, 78, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "RGBA(8, 160, 140, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "RGBA(8, 160, 140, 1)",
                  },
                  {
                    offset: 1,
                    color: "RGBA(5, 84, 78, 1)",
                  },
                  // {
                  //   offset: 0.6,
                  //   color: 'RGBA(6, 116, 106, 1)'
                  // },
                  {
                    offset: 1,
                    color: "RGBA(5, 85, 80,.9)", // 100% 处的颜色
                  },
                ],
              },
            },
            {
              symbol: "rect",
              lt: 1,
              label: "0家",
              color: "#99CCCC",
            },
          ],
          inRange: {
            color: ["lightskyblue", "yellow", "rgba(8, 255, 206, 1)", "red"],
          },
        },
      ];
      let colorMap = [];
      for (const key in this.chartData) {
        colorMap.push({
          name: key,
          value: this.chartData[key],
        });
      }
      /*       this.options.bmap = {
        center: [104.114129, 37.550339],
        zoom: 1,
        roam: true,
        mapStyle: {
          styleJson: [
            {
              featureType: "water",
              elementType: "all",
              stylers: {
                color: "#044161",
              },
            },
            {
              featureType: "land",
              elementType: "all",
              stylers: {
                color: "#004981",
              },
            },
            {
              featureType: "boundary",
              elementType: "geometry",
              stylers: {
                color: "#064f85",
              },
            },
            {
              featureType: "railway",
              elementType: "all",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                color: "#004981",
              },
            },
            {
              featureType: "highway",
              elementType: "geometry.fill",
              stylers: {
                color: "#005b96",
                lightness: 1,
              },
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "arterial",
              elementType: "geometry",
              stylers: {
                color: "#004981",
              },
            },
            {
              featureType: "arterial",
              elementType: "geometry.fill",
              stylers: {
                color: "#00508b",
              },
            },
            {
              featureType: "poi",
              elementType: "all",
              stylers: {
                visibility: "off",
              },
            },
            {
              featureType: "green",
              elementType: "all",
              stylers: {
                color: "#056197",
                visibility: "off",
              },
            },
            {
              featureType: "subway",
              elementType: "all",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "manmade",
              elementType: "all",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "local",
              elementType: "all",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "arterial",
              elementType: "labels",
              stylers: {
                visibility: "on",
              },
            },
            {
              featureType: "boundary",
              elementType: "geometry.fill",
              stylers: {
                color: "#029fd4",
              },
            },
            {
              featureType: "building",
              elementType: "all",
              stylers: {
                color: "#1a5787",
              },
            },
            {
              featureType: "label",
              elementType: "all",
              stylers: {
                visibility: "off",
              },
            },
          ],
        },
      }; */
      /*  this.options.series[0] = {
        name: "区域产量",
        type: "map",
        geoIndex: 0,
        data: colorMap,
      }; */
      this.options.series[0] = {
        type: "effectScatter",
        coordinateSystem: "geo",
        data: [
          {
            name: "郑州",
            value: ["113.655608", "34.757479", 30],
          },
          {
            name: "洛阳",
            value: ["112.446273", "34.701943", 100],
          },
        ],
        itemStyle: {
          opacity: 1,
        },
        animation: false,
        silent: true,

        z: 100,
      };
      this.options.series[1] = {
        type: "custom",
        coordinateSystem: "geo",
        renderItem: this.renderItem,
        itemStyle: {
          opacity: 0.5,
        },
        animation: false,
        silent: true,
        data: [0],
        z: -10,
      };

      this.chart.setOption(this.options);
    },
    getGeoJson() {
      axios.get(this.geoPath).then((res) => {
        let geoJson = res.data;
        let mapName = "henan";
        echarts.registerMap(mapName, geoJson);
        this.setChartData();
      });
    },
    initChart(cle) {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
        this.chart.on("click", function (params) {
          vmm.chartClick(params);
        });
        this.chart.on("mouseOver", function (params) {
          if (params.componentSubType === "effectScatter") {
          } else {
            vmm.chartHover(params);
          }
        });
        this.chart.on("mouseOut", function (params) {
          vmm.chartOut(params);
        });
        this.chart.on("globalout", function (params) {
          vmm.globalout("globalout", params);
        });
      }
      this.getGeoJson();
    },
  },
};
</script>
